export default __webpack_public_path__ + "static/wpLandingAdPageBg-f0e01f8ec432572a0c1cca0ee5267262.png";